__turbopack_context__.v({
  "carousel": "styles-module-scss-module__8BFghW__carousel",
});
